module.exports = __webpack_public_path__ + "img/city3.bade0f8.jpg";